document.addEventListener('turbolinks:load', () => {

    const SgPreviewFontSizeSelectForm = document.getElementById('SgPreviewFontSizeSelectForm')
    const sgScreen = document.getElementById('sgScreenGuest') || document.getElementById('sgScreen')
    const sgPreviewFontSizeHeader = document.getElementById('sgPreviewFontSizeHeader')
    const fontSizeSelectButton = document.getElementById('fontSizeSelectButton')
    const sgPreviewNextArrow = document.getElementById('sgPreviewNextArrow')

    if (sgScreen !== null && SgPreviewFontSizeSelectForm !== null) {
        SgPreviewFontSizeSelectForm.addEventListener('submit', function (e) {
            if ($("input[name=fontSize]:checked").length !== 1) {
                e.preventDefault()
                return false
            }
        })

        $("input[name=fontSize]").on('click', function(e) {
            changeFontSize(e.target.value)
        })

    }

    function changeFontSize(size){
        let fontSize = 0
        let buttonFontSize = 0
        let arrowFontSize = 0
        const currentSgScreenHeight = sgScreen.getBoundingClientRect().height
        if (size === "large"){
            fontSize = currentSgScreenHeight / 30
            buttonFontSize = currentSgScreenHeight / 28
            arrowFontSize = currentSgScreenHeight * 0.046
        } else if(size === "very large"){
            fontSize = currentSgScreenHeight / 25
            buttonFontSize = currentSgScreenHeight / 22
            arrowFontSize = currentSgScreenHeight * 0.058
        } else {
            fontSize = currentSgScreenHeight / 42
            buttonFontSize = currentSgScreenHeight / 39
            arrowFontSize = currentSgScreenHeight * 0.033
        }

        let texts = $(".fontSizeText")
        for (let text of texts){
            //Set text-size as class to use it during resizing the window
            setSizeClass(text, size)
            // Resizing the text
            setSizeStyle(text, fontSize)
        }
        setSizeClass(sgPreviewFontSizeHeader, size)
        setSizeStyle(sgPreviewFontSizeHeader, fontSize)
        setButtonSizeClass(fontSizeSelectButton, size)
        setSizeStyle(fontSizeSelectButton, buttonFontSize)
    }

    function setSizeClass(element, size){
        // delete text sizes
        element.classList.remove('text-lg')
        element.classList.remove('text-xl')
        element.classList.remove('text-2xl')
        //add current used text-size
        if (size === "large"){
            element.classList.add('text-xl')
        } else if(size === "very large"){
            element.classList.add('text-2xl')
        } else {
            element.classList.add('text-lg')
        }
    }

    function setButtonSizeClass(element, size){
        // delete text sizes
        element.classList.remove('text-lg2')
        element.classList.remove('text-xl2')
        element.classList.remove('text-2xl2')
        //add current used text-size
        if (size === "large"){
            element.classList.add('text-xl2')
        } else if(size === "very large"){
            element.classList.add('text-2xl2')
        } else {
            element.classList.add('text-lg2')
        }
    }

    function setSizeStyle(element, fontSize){
        element.style.fontSize = `${fontSize}px`
        element.style.lineHeight = `${fontSize}px`
    }
})